<template lang="pug">
  div.color-filter
    div.common-condition.condition
      div.condition-name
        slot(name="name") Color
    ul
      li.color-wrap(title="color",v-for="color in colors", :key="color.name")
        div.color(:style=" `background:${color.value}`",  :class="`color-${color.name}`")
</template>
<script>
export default {
  name: 'ColorFilter',
  data () {
    return {
      colors: [
        {
          name: 'white',
          value: '#ffff'
        },
        {
          name: 'red',
          value: '#f00'
        },
        {
          name: 'grey',
          value: '#ccc'
        },
        {
          name: 'green',
          value: '#0f0'
        },
        {
          name: ' blue',
          value: '#00f'
        }
      ]
    }
  }
}
</script>
<style lang = "scss" scoped>
.condition {
  padding: 0 1.25rem;
}

.condition-name {
  margin: 1.25rem 0 .9375rem;
  padding: 0 0 .625rem .0625rem;
  font-size: 1.125rem;
  line-height: 1em;
  border-bottom: 1px solid #e7e7ef;
  color: #1a1a1a;
  text-transform: uppercase;
}
.color-filter {
  padding: 0 1.25rem;
}
ul {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
}
ul li {
  position: relative;
  width: 20%;
  padding: 0 .1875rem .375rem;
  position: relative;
}

.color {
  background: #000;
  border: 1px solid transparent;
  padding-top: 50%;
}

.color-white {
  border-color: #b7b7bf;
}

@media only screen and (min-width: 768px) {

    ul li {
      width: calc(100%/3);
    }
}

</style>
